module.exports = {
      id: "inc-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#inc",
      toString: function () {
        return this.url;
      }
    }